<template>
    <Wrapper class="gallery">
        <div class="row">
            <div class="col-1 text-right flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <div class="font-weight-light">
                    2019<br/>
                    01/05
                </div>
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col-auto text-center flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <h5 class="m-0">
                    <span class="badge badge-pill border border-secondary">&nbsp;</span>
                </h5>
                <div class="row h-50">
                    <div class="col border-right border-secondary">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col py-2">
                <div class="card bg-transparent border-0 text-primary">
                    <div class="card-body">
                        <div class="float-right"><i class="icons icon-check"></i></div>
                        <p class="card-title text-uppercase">Day 1 Orientation</p>
                        <div class="row no-gutters">
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=28')"><img alt="gallery placeholder" src="assets/gradients/28.jpg" class="mr-2 mb-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=35')"><img alt="gallery placeholder" src="assets/gradients/35.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=30')"><img alt="gallery placeholder" src="assets/gradients/30.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=9')"><img alt="gallery placeholder" src="assets/gradients/9.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=10')"><img alt="gallery placeholder" src="assets/gradients/10.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=24')"><img alt="gallery placeholder" src="assets/gradients/24.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=9')"><img alt="gallery placeholder" src="assets/gradients/9.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=23')"><img alt="gallery placeholder" src="assets/gradients/23.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/79.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=28')"><img alt="gallery placeholder" src="assets/gradients/28.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=42')"><img alt="gallery placeholder" src="assets/gradients/42.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=3')"><img alt="gallery placeholder" src="assets/gradients/3.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=19')"><img alt="gallery placeholder" src="assets/gradients/19.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=66')"><img alt="gallery placeholder" src="assets/gradients/66.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=4')"><img alt="gallery placeholder" src="assets/gradients/4.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-1 text-right flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <div class="font-weight-light">
                    2019<br/>
                    01/06
                </div>
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col-auto text-center flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col border-right border-secondary">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <h5 class="m-0">
                    <span class="badge badge-pill border border-secondary">&nbsp;</span>
                </h5>
                <div class="row h-50">
                    <div class="col border-right border-secondary">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col py-2">
                <div class="card bg-transparent border-0 text-primary">
                    <div class="card-body">
                        <div class="float-right"><i class="far fa-clock"></i> <i class="icons icon-check"></i></div>
                        <p class="card-title text-uppercase">Day 2 Sessions</p>
                        <div class="row no-gutters">
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=21')"><img alt="gallery placeholder" src="assets/gradients/21.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=19')"><img alt="gallery placeholder" src="assets/gradients/19.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=3')"><img alt="gallery placeholder" src="assets/gradients/3.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=42')"><img alt="gallery placeholder" src="assets/gradients/42.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=66')"><img alt="gallery placeholder" src="assets/gradients/66.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=24')"><img alt="gallery placeholder" src="assets/gradients/24.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=28')"><img alt="gallery placeholder" src="assets/gradients/28.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-1 text-right flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <div class="font-weight-light">
                    2019<br/>
                    01/07
                </div>
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col-auto text-center flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col border-right border-secondary">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <h5 class="m-0">
                    <span class="badge badge-pill border border-secondary">&nbsp;</span>
                </h5>
                <div class="row h-50">
                    <div class="col border-right border-secondary">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col py-2">
                <div class="card bg-transparent border-0 text-primary">
                    <div class="card-body">
                        <div class="float-right"><i class="icons icon-check"></i></div>
                        <p class="card-title text-uppercase">Day 3 Sessions</p>
                        <div class="row no-gutters">
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=24')"><img alt="gallery placeholder" src="assets/gradients/24.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=66')"><img alt="gallery placeholder" src="assets/gradients/66.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=19')"><img alt="gallery placeholder" src="assets/gradients/19.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=35')"><img alt="gallery placeholder" src="assets/gradients/35.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=10')"><img alt="gallery placeholder" src="assets/gradients/10.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=99')"><img alt="gallery placeholder" src="assets/gradients/19.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=4')"><img alt="gallery placeholder" src="assets/gradients/4.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=9')"><img alt="gallery placeholder" src="assets/gradients/9.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=23')"><img alt="gallery placeholder" src="assets/gradients/23.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-1 text-right flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <div class="font-weight-light">
                    2019<br/>
                    01/09
                </div>
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col-auto text-center flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div class="col border-right border-secondary">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
                <h5 class="m-0">
                    <span class="badge badge-pill border border-secondary">&nbsp;</span>
                </h5>
                <div class="row h-50">
                    <div class="col">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col py-2">
                <div class="card bg-transparent border-0 text-primary">
                    <div class="card-body">
                        <div class="float-right"><i class="icons icon-check"></i></div>
                        <p class="card-title text-uppercase">Day 4 Exhibitions</p>
                        <div class="row no-gutters">
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=23')"><img alt="gallery placeholder" src="assets/gradients/23.jpg" class="mr-2 mb-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/21.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/79.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/42.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/21.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=19')"><img alt="gallery placeholder" src="assets/gradients/19.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=9')"><img alt="gallery placeholder" src="assets/gradients/9.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/23.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/30.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/24.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/20.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=4')"><img alt="gallery placeholder" src="assets/gradients/4.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=3')"><img alt="gallery placeholder" src="assets/gradients/3.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=79')"><img alt="gallery placeholder" src="assets/gradients/79.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=66')"><img alt="gallery placeholder" src="assets/gradients/66.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                            <div class="col-2 col-sm-auto">
                                <a href="#" @click="openModal('//gradientjoy.com/600x300?id=30')"><img alt="gallery placeholder" src="assets/gradients/30.jpg" class="mb-2 mr-2 img-fluid" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="galleryModal2" ref="galleryModal2" v-if="showModal" class="modal d-block" tabIndex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content bg-dark">
                    <div class="modal-header border-0">
                        <h5 class="font-weight-light text-white mb-0" id="galleryTitle">Image</h5>
                        <button type="button" class="close float-right text-dark" aria-label="Close" @click="closeModal">
                          <span aria-hidden="true">&#xD7;</span>
                        </button>
                    </div>
                    <div class="modal-body p-0 text-center bg-alt">
                        <img v-show="selected.imageSrc" :src="selected.imageSrc" id="galleryImage" alt="Gallery" class="loaded-image mx-auto img-fluid" />
                        <div v-show="!selected.imageSrc">
                            <div class="d-flex justify-content-center">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0">
                        <button class="btn btn-outline-primary" type="button" @click="closeModal">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper } from '../components';

export default {
    data() {
        return {
            showModal: false,
            selected: {}
        }
    },
    components: {
        Wrapper
    },
    methods: {
        openModal(src) {
            this.selected = {
                imageSrc: src
            }
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        }
    }
};
</script>
